<script setup>
import LinearLogo from '@/assets/icons/LinearLogo.vue'
import { useRoute } from 'vue-router'
import { onMounted, ref } from 'vue'
import { useAuth0 } from '@auth0/auth0-vue'
import router from '@/router/index.js'
import { store } from '@/store.js'

const route = useRoute()
const { getAccessTokenSilently } = useAuth0()

const errorMessage = ref(null)
const message = ref(null)

onMounted(async () => {
  const state = route.query.state

  if(localStorage.getItem('LINEAR_ACCESS_TOKEN')){
    return
  }


  if (!isValidState(state)) {
    await handleRedirectWithError()
    return
  }

  message.value = 'Successfully retrieved Linear Code'
  await new Promise(resolve => setTimeout(resolve, 1800))

  const code = route.query.code
  if (!code) {
    await handleRedirectWithError()
    return
  }

  message.value = 'Requesting Access Token to communicate with Linear...'
  const isAuthenticated = await requestLinearAccess(code)
  await new Promise(resolve => setTimeout(resolve, 1800))

  if (!isAuthenticated) {
    await handleRedirectWithError()
    return
  }

  await handleRedirect()

})

async function handleRedirect() {
  message.value = 'Success! Closing this window...'
  await new Promise(resolve => setTimeout(resolve, 2200))
  window.close()
}

async function handleRedirectWithError() {
  errorMessage.value = 'Something went wrong validating your authorization, please try again.\n Closing this window...'
  await new Promise(resolve => setTimeout(resolve, 5000))
  window.close()
}

function isValidState(state) {
  //TODO state validation
  return true
}

async function requestLinearAccess(code) {
  const token = await getAccessTokenSilently()
  const redirectUri = `${window.location.origin}/callback-linear`

  const linearTokenResponse = await fetch(`${import.meta.env.VITE_BACKEND_BASE_URL}/users/linear/access-token`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      code,
      redirectUri
    })
  })

  if (linearTokenResponse.status !== 200) {
    return false
  }

  const linearToken = await linearTokenResponse.json()
  localStorage.setItem('LINEAR_ACCESS_TOKEN', linearToken.access_token)
  return true
}

</script>
<template>
  <template>
    <div class="grid min-h-full place-items-center px-6 py-24 sm:py-32 lg:px-8">
      <div class="text-center flex flex-col items-center">
        <p class="text-base font-semibold text-violet-400">Aesti Connecting With</p>
        <LinearLogo class="mt-6" />
        <p v-if="!errorMessage" class="mt-6 text-base leading-7 text-gray-200">{{ message }}</p>
        <p v-if="errorMessage" class="mt-6 text-base leading-7 text-red-200 whitespace-pre-line">{{ errorMessage }}</p>
      </div>
    </div>
  </template>
</template>
